module.exports = __webpack_public_path__ + "img/pauli-x-root-26.42ea7d1e.svg";